var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":_vm.url,"target":_vm.external ? '_blank' : false,"rel":_vm.behaviour ? _vm.behaviour : false}},[(_vm.image)?_c('hp-image',_vm._b({},'hp-image',_vm.image,false)):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1),(_vm.eyeCatcher)?_c('sup',[_vm._v(" "+_vm._s(_vm.eyeCatcher)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }